import { PrivateAPINamespace } from '../PrivateAPINamespace';
export class InfoNamespace extends PrivateAPINamespace {
    getMetaSiteId() {
        return this.ps.ds.generalInfo.getMetaSiteId();
    }
    getUser() {
        return this.ps.ds.generalInfo.getUserInfo().userId;
    }
    getEditorSessionId() {
        return this.ps.hostAPI.editor.info.getEditorSessionId();
    }
    getAppInstance(appDefinitionId) {
        return this.ps.ds.platform.getAppDataByAppDefId(appDefinitionId)?.instance;
    }
    getLanguageCode() {
        return this.ps.ds.generalInfo.getLanguage();
    }
    getViewMode() {
        return this.ps.ds.viewMode.get();
    }
    getEditorType() {
        // @ts-expect-error
        return window?.commonConfig?.brand;
    }
}
InfoNamespace.namespace = 'info';
//# sourceMappingURL=InfoNamespace.js.map